import { StoresService } from '@stores/stores.service';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../modules/auth/auth.service';
import { BehaviorSubject, filter, take } from 'rxjs';

import { LanguageService } from './language.service';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    private _auth = inject(AuthService);
    private _store = inject(StoresService);
    private _languageService = inject(LanguageService);

    private _showBack$ = new BehaviorSubject(true);
    public showBack$ = this._showBack$.asObservable();

    constructor() {
        this._store.initialize();
        this._languageService.initLanguage();
        this._auth.isAuthenticated$
            .pipe(
                filter((isAuthenticated) => isAuthenticated),
                take(1)
            )
            .subscribe(() => {
                this._store.initialize();
            })
    }

    public topbarBackToggle(show: boolean) {
        this._showBack$.next(show);
    }

    public logout() {
        this._store.cleanup();
        this._auth.logout();
    }
}
